const teachingpoint = {
    state: {
        addTeachingPointDialog: {
            title: '新增校区信息',
            type: 'add'
        }
    },
    getters: {
        addTeachingPointDialog: state => state.addTeachingPointDialog,
    },
    mutations: {
        SET_TEACHING_POINT_DIALOG_TITLE: (state, type) => {
            console.log("SET_TEACHING_POINT_DIALOG_TITLE");
            if (type === 'add') {
                state.addTeachingPointDialog.title = '新增地点信息'
                state.addTeachingPointDialog.type = 'add'
            } else {
                state.addTeachingPointDialog.title = '编辑地点信息'
                state.addTeachingPointDialog.type = 'edit'
            }
        }
    },
    actions: {

    }
}

export default teachingpoint